import MapMaker from "../utils/MapMaker";

export default class BlockMap {
	static init() {
		const blockMaps = document.querySelectorAll(".map");
		if (!blockMaps.length) return;

		const initMaps = () => {
			// sécurité : on vérifie que le constructeur est bien dispo
			if (!window.google?.maps?.Map) {
				console.warn("[BlockMap] google.maps.Map non disponible, retry dans 100ms...");
				setTimeout(initMaps, 100);
				return;
			}

			blockMaps.forEach((mapContainer) => {
				const mapInner = mapContainer.querySelector(".map-inner");
				if (!mapInner) return;

				const markers = mapContainer.querySelectorAll(".map-marker");
				if (!markers.length) return;

				if (mapInner.dataset.type === "static") {
					MapMaker.createStaticMap(mapInner, markers);
					return;
				}

				let map;
				try {
					map = MapMaker.createDynamicMap(mapInner);
				} catch (err) {
					console.error("[BlockMap] Erreur lors de la création de la carte :", err);
					return;
				}

				if (!map) {
					console.warn("[BlockMap] Map non créée pour", mapContainer);
					return;
				}

				markers.forEach((el) => MapMaker.createMarker(el, map));

				this.allMarkerPairs = Array.from(map.markers).map((gm, i) => ({
					gm,
					dom: markers[i],
				}));

				this.allGmMarkers = this.allMarkerPairs.map((p) => p.gm);
				this.map = map;

				MapMaker.updateBounds(map);
				MapMaker.createMarkerClusterer(map, map.markers);

				const filters = mapContainer.querySelectorAll(".map-legend .marker-label");
				if (filters.length) {
					filters.forEach((filter) => {
						filter.addEventListener("click", () => {
							const isActive = filter.classList.toggle("active");
							filters.forEach((f) => f !== filter && f.classList.remove("active"));
							this.applyFilterAndRefresh(null, isActive ? filter.dataset.id : null);
						});
					});
				}
			});
		};

		// 🔒 sécurité : vérifier Map bien dispo
		if (window.google?.maps?.Map) {
			initMaps();
		} else {
			// on écoute l’événement custom
			const listener = () => {
				window.removeEventListener("googleMapApiLoaded", listener);
				initMaps();
			};
			window.addEventListener("googleMapApiLoaded", listener, { once: true });
		}
	}

	static applyFilterAndRefresh(_, filter, { fit = true } = {}) {
		try {
			const iw = MapMaker.getInfoWindow(this.map);
			if (iw && typeof iw.close === "function") iw.close();
		} catch (_) {}

		const allPairs = Array.isArray(this.allMarkerPairs) ? this.allMarkerPairs : [];
		const activePairs = filter
			? allPairs.filter((p) => p.dom?.dataset?.id === filter)
			: allPairs;

		const allGm = allPairs.map((p) => p.gm);
		const activeGm = activePairs.map((p) => p.gm);

		console.debug("[BlockMap] applyFilterAndRefresh", {
			filter,
			totalPairs: allPairs.length,
			activePairs: activePairs.length,
		});

		allGm.forEach((m) => m?.setVisible?.(false));
		activeGm.forEach((m) => m?.setVisible?.(true));

		const mc =
			this.map?.markerClusterer ||
			this.map?.clusterer ||
			this.map?.markerclusterer;

		if (mc) {
			if (typeof mc.clearMarkers === "function") mc.clearMarkers();
			else if (typeof mc.setMarkers === "function") mc.setMarkers([]);

			if (typeof mc.addMarkers === "function") mc.addMarkers(activeGm);
			else if (typeof mc.setMarkers === "function") mc.setMarkers(activeGm);

			mc.repaint?.();
			mc.render?.();
		}

		if (fit) {
			const go = () => MapMaker.updateBounds(this.map, activeGm);
			requestAnimationFrame(() => requestAnimationFrame(go));
		}
	}
}
